// 액세스 코드 및 복구 코드 생성 함수 (기존 로직 유지)
export function generateCode(length = 20) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function generateGuestName() {
  const randomNum = Math.floor(1000 + Math.random() * 9000) // 1000~9999
  return `손님${randomNum}`
}

export const heavenlyStems = [
  '甲',
  '乙',
  '丙',
  '丁',
  '戊',
  '己',
  '庚',
  '辛',
  '壬',
  '癸',
]
export const earthlyBranches = [
  '子',
  '丑',
  '寅',
  '卯',
  '辰',
  '巳',
  '午',
  '未',
  '申',
  '酉',
  '戌',
  '亥',
]

export function getGanjiByYear(year) {
  const stem = heavenlyStems[(year - 4) % 10]
  const branch = earthlyBranches[(year - 4) % 12]
  return `${stem}${branch}`
}
